import React from 'react';
import styles from '../styles/CadmiumSpinner.module.css';

const CadmiumSpinner = ({ message = "Request is processing, please wait." }) => {
    return (
        <div className={styles.spinnerOverlay}>
            <div className={styles.spinner}>
                <div className={styles.spinnerCircleText}></div>
            </div>
            <div className={styles.spinnerMessageBox}>
                <h2 className={styles.spinnerTitle}>Cadmium</h2>
                <p className={styles.spinnerMessage}>{message}</p>
            </div>
        </div>
    );
};

export default CadmiumSpinner;
